import React, { useEffect, useState } from "react";
import { Button } from "src/business-types/grocery/components/Button";
import AddCustomer from "./AddCustomer";
import EditCustomer from "./EditCustomer";
import useCustomer from "../../../hooks/useCustomer";
import { CustomerData } from "src/shared/types";
import { CustomerTable, Table } from "../settingInterface";
import { useSearch } from "../../../components/SearchContext";
import CommonTable from "../../../components/CommonTable";
import { deleteCustomer } from "../../../../../shared/services/services";
import LoadingScreen from "../../../../../shared/components/LoadingScreen";
import { TablePagination } from "@mui/material";
import { notifyError, notifySuccess, notifyWarning } from "../../../../../assets/toastService";
import PopupModules from "src/features/auth/components/PopupModules";
import { useUser } from "src/shared/context/UserContext";
import iconMap from "src/assets/icons/Icons";

const customerHeaderCell: Table<CustomerTable>[] = [
  { id: "S.No", label: "S.No", numeric: false, sorting: false },
  { id: "Name", label: "Customer Name", numeric: false },
  { id: "phone_number", label: "Phone Numbers", numeric: false },
  { id: "Email", label: "Email Ids", numeric: false },
];

const Customer = () => {
  const [viewDeleted, setViewDeleted] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [editCustomer, setEditCustomer] = useState<CustomerData>();
  const [confirmDeleteList, setConfirmDeleteList] = useState<string[]>([]);
  const [selectedIds, setSelectedIds] = useState<(string | number)[]>([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const { userConfigration } = useUser();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [showDropdown, setShowDropdown] = useState(false);

  //sorting
  const [orderby, setOrderBy] = useState("");
  const [field, setField] = useState("");
  const DownArrow = iconMap["down"];

  const { searchTerm } = useSearch();
  const { customer, loading: dataLoading, onlyCustomer } = useCustomer(refresh, viewDeleted, page + 1, rowsPerPage, searchTerm, field, orderby);

  const handleDeleteSelected = (ids: (string | number)[]) => {
    const selected = customer?.customer_details.filter((c) => ids.includes(c._id.$oid)) || [];
    setSelectedIds(ids);
    setConfirmDeleteList(selected.map((c) => c.firstName + " " + c.middleName + " " + c.lastName));
  };

  useEffect(() => {
    setRowsPerPage(userConfigration?.tableDefaultSize || 10);
  }, [userConfigration]);

  const handleDeleteConfirm = async () => {
    try {
      setLoading(true);
      await deleteCustomer(selectedIds);
      notifySuccess("Customer deleted successfully");
      handleClose();
    } catch (err) {
      console.error(err);
      notifyError("try again later");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = (data?: any) => {
    setIsAddModalOpen(false);
    setEditCustomer(undefined);
    setConfirmDeleteList([]);
    setRefresh((r) => !r);
  };

  const handlePageChange = (_: unknown, newPage: number) => setPage(newPage);
  const handleRowsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const tableData: CustomerTable[] = onlyCustomer.map((c, i) => ({
    "S.No": page * rowsPerPage + i + 1,
    Name: c.firstName + " " + c.middleName + " " + c.lastName,
    phone_number: <div className="flex flex-col "><p>Primery : {c.phones?.find((p) => p.isPrimary)?.phone || ""}</p><p>Secondary : {c.phones?.filter((p) => !p.isPrimary).map((p) => p.phone).join(", ") || ""}</p></div>,
    Email: <div className="flex flex-col "><p>Primery : {c.emails?.find((e) => e.isPrimary)?.email || ""}</p><p>Secondary : {c.emails?.filter((e) => !e.isPrimary).map((e) => e.email).join(", ") || ""}</p></div>,
    id: c._id?.$oid,
  }));

  return (
    <div className='w-full h-full overflow-y-auto bg-white rounded-2xl shadow m-1'>
      {/* Top Controls */}
      <div className='w-full flex justify-end '>
        <div className='w-full flex justify-end gap-4 px-14 pt-1'>
          <div className='flex items-center gap-2 cursor-pointer ' onClick={() => setViewDeleted(!viewDeleted)}>
            <input type='checkbox' className='w-5 h-5' checked={viewDeleted} readOnly />
            <p className='w-40'>View deleted</p>
          </div>
          <Button label='+ Customer' className="p-2 w-fit h-fit mt-4" variant='ThemeBase' onClick={() => setIsAddModalOpen(true)} />
          <Button variant='ThemeBase' onClick={() => { notifyWarning("Comming Zoon") }} icon={DownArrow} iconPosition='right' label='More Options' className="p-2 w-fit h-fit mt-4" />
          {showDropdown && (
            <div className='absolute mt-16 right-16 bg-white border rounded shadow-lg z-10 w-32'>
              <button
                className='w-full px-4 py-2 text-left hover:bg-gray-100'
                onClick={() => {
                  setShowDropdown(false);
                }}
              >
                Export
              </button>

              <button
                className='w-full px-4 py-2 text-left hover:bg-gray-100'
                onClick={() => {
                  setShowDropdown(false);
                }}
              >
                Import
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Table */}
      <div className=' rounded-lg overflow-auto flex justify-center'>
        <div className='w-full flex flex-col items-center'>
          <CommonTable<CustomerTable>
            data={tableData}
            headCells={customerHeaderCell}
            title=''
            onDeleteSelected={handleDeleteSelected}
            onEditSelected={(id) => setEditCustomer(customer?.customer_details.find((c) => c._id.$oid === id))}
            pageSize={rowsPerPage}
            selectable={false}
            Action={!viewDeleted}
            pagenation={false}
            shortByTable={false}
            OrderType={(data) => {
              setField(data.field);
              setOrderBy(data.orderby);
            }}
          />

          {/* Pagination */}
          <div className='w-[95%] bg-white border rounded-b-md -mt-1 mb-4'>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component='div'
              count={customer?.totalRecords || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsChange}
            />
          </div>
        </div>
      </div>

      {/* Modals */}
      <AddCustomer close={handleClose} loading={setLoading} addCustomer={isAddModalOpen} />
      {editCustomer && <EditCustomer close={handleClose} prvCustomer={editCustomer} loading={setLoading} editCustomer={true} />}

      {/* Delete Popup */}
      <PopupModules isOpen={!!confirmDeleteList.length} onClose={() => setConfirmDeleteList([])} title='Confirm Deletion'>
        <div className='w-full text-center px-4 py-2'>
          <p className='text-sm text-gray-600 mb-4'>
            The following customers will be <span className='font-semibold text-red-600'>DELETED</span>.<br />
            This action <span className='font-semibold'>cannot be undone.</span>
          </p>

          <div className='max-h-40 overflow-y-auto border rounded-md p-3 bg-gray-50 mb-5'>
            {confirmDeleteList.map((name, idx) => (
              <div key={idx} className='flex items-center text-sm border-b last:border-none py-1'>
                <span className='w-6 text-gray-500'>{idx + 1}.</span>
                <span className='flex-1 text-left text-gray-700'>{name}</span>
              </div>
            ))}
          </div>

          <div className='flex justify-center gap-4'>
            <Button label='Cancel' variant='ThemeCancel' className='border' onClick={() => setConfirmDeleteList([])} />
            <Button label='Delete' variant='danger' onClick={handleDeleteConfirm} />
          </div>
        </div>
      </PopupModules>
      {(loading || dataLoading) && <LoadingScreen />}
    </div>
  );
};

export default Customer;
